import { render, staticRenderFns } from "./material-batch-upload-dialog.vue?vue&type=template&id=0978a37e"
import script from "./material-batch-upload-dialog.vue?vue&type=script&lang=js"
export * from "./material-batch-upload-dialog.vue?vue&type=script&lang=js"
import style0 from "./material-batch-upload-dialog.vue?vue&type=style&index=0&id=0978a37e&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports